import { render, staticRenderFns } from "./flashsale.vue?vue&type=template&id=2ee3a994&"
import script from "./flashsale.vue?vue&type=script&lang=js&"
export * from "./flashsale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports